module.exports = __webpack_public_path__ + "static/media/facebook.995fcb13.svg";